<template>
  <div>
    <span v-if="tipoLog == 'info'" class="size-status" style="color: #3fa6f4">
      <v-icon small color="#3fa6f4" class="icon-status pb-1">mdi-alert-circle-outline</v-icon>
      Info
    </span>
    <span v-else-if="tipoLog == 'notice'" class="size-status" style="color: green">
      <v-icon small color="green" class="icon-status pb-1">mdi-magnify</v-icon>
      Notice
    </span>
    <span v-else-if="tipoLog == 'debug'" class="size-status" style="color: green">
      <v-icon small color="green" class="icon-status pb-1">mdi-magnify</v-icon>
      Debug
    </span>
    <span v-else-if="tipoLog == 'critical'" class="size-status" style="color: red">
      <v-icon small color="red" class="icon-status pb-1">mdi-block-helper</v-icon>
      Critical
    </span>
    <span v-else-if="tipoLog == 'emergency'" class="size-status" style="color: red">
      <v-icon small color="red" class="icon-status pb-1">mdi-block-helper</v-icon>
      Emergency
    </span>

    <span v-else-if="tipoLog == 'alert'" class="size-status" style="color: #e8a633">
      <v-icon small color="#e8a633" class="icon-status pb-1">mdi-alert</v-icon>
      Alert
    </span>
    <span v-else-if="tipoLog == 'warning'" class="size-status" style="color: #e8a633">
      <v-icon small color="#e8a633" class="icon-status pb-1">mdi-alert</v-icon>
      Warning
    </span>
    <span v-else class="size-status" style="color: red">
      <v-icon small color="red" class="icon-status pb-1">mdi-block-helper</v-icon>
      Error
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      tipoLog: {
        type: String,
        required: true
      }
    }
  };
</script>
<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }

  .size-status .v-icon {
    font-size: 0.9rem !important;
  }

  .icon-status {
    margin-right: 1.7px !important;
  }
</style>